<template>
    <div style="width: 100%; height: calc(100% - 48px); display: flex; flex-direction: column; justify-content: stretch">
        <div style="flex-grow: 0; padding: 10px; display: flex;">
            <div style="width: 500px;">
                <search-bar
                        reactivity="input"
                        v-model="search" placeholder="검색"></search-bar>
            </div>
            <v-spacer></v-spacer>
        </div>
        <div style="flex-grow: 1;  overflow-y: auto; height: 100%; display: flex; justify-content: center; align-items: center;">
            <template v-if="!loading">
                <system-permission-tree-view
                        :items="items"
                        :search="search"
                        type="SYSTEM"
                        @click:restore="onRestoreClicked"
                        @click:delete="onDeleteClicked"
                        @click:delete-permanently="onDeletePermanentlyClicked"
                />
            </template>
            <template v-else>
                <div>
                    <v-progress-circular indeterminate size="48" :color="'primary'"
                    ></v-progress-circular>
                    <div class="mt-3">로드중...</div>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
    import SystemPermissionTreeView from "@/views/permission/manage/SystemPermissionTreeView";
    import {PATH} from "@/constants";
    import {PermissionTree} from "@/assets/plugins/mps-common/user/permission-manager";
    import SearchBar from "@/components/input/SearchBar";
    import OnSystemPermissionReceivedListener from "@/framework/listeners/OnSystemPermissionReceivedListener";

    export default {
        name: "SystemPermissionManageBySystem",
        components: {SearchBar, SystemPermissionTreeView},
        mixins: [OnSystemPermissionReceivedListener],
        data() {
            return {
                search: "",
                loading: false,
                /**
                 * 서버에서 수신한 전체 권한
                 */
                permissions: [],
                /**
                 * 권한을 트리 형태로 관리해주는 객체
                 */
                permissionTree: undefined,
            }
        },
        computed: {
            items() {
                if (!this.permissionTree) return [];
                return this.permissionTree.items;
            }
        },
        created() {
            this.loadPermissions();
        },
        methods: {
            async loadPermissions() {
                this.loading = true;
                const response = await this.$request(PATH.SYSTEM_PERMISSION.ALL_PERMISSION_BY_SYSTEM)
                    .post()
                    .enqueue();
                this.permissionTree = new PermissionTree(response.data);
                this.loading = false;
            },

            /**
             * 권한을 복구합니다.
             *
             * 권한을 복구하면 부모 노드의 권한까지 모두 복구됩니다.
             */
            onRestoreClicked(node) {
                this.$confirm('권한을 복구합니다. 모든 부모 권한 또한 복구됩니다. 복구하시겠습니까?')
                    .then(() => this.requestRestore(node));
            },

            /**
             * 서버에 권한 복구 요청을 합니다.
             */
            async requestRestore(node) {
                await this.$requestWithOverlay(PATH.SYSTEM_PERMISSION.RESTORE)
                    .setObject({id: node.id})
                    .enqueue();
                await this.loadPermissions();
            },

            /**
             * 권한을 삭제처리힙니다..
             *
             * 자식의 권한도 모두 삭제처리됩니다.
             *
             * 물리적인 DB 에서 실제로 삭제되지는 않지만 플래그로 구분합니다.
             */
            onDeleteClicked(node) {
                this.$confirm('권한을 삭제처리합니다. 물리 DB 에서 삭제되지는 않지만 플래그로 삭제 처리합니다. 삭제처리된 권한은 유저들이 접근하지 못합니다.')
                        .then(() => this.requestDelete(node));
            },

            /**
             * 서버에 권한 삭제 처리 요청을 합니다.
             */
            async requestDelete(node) {
                await this.$requestWithOverlay(PATH.SYSTEM_PERMISSION.DELETE)
                    .setObject({id: node.id})
                    .enqueue();
                await this.loadPermissions();
            },

            /**
             * 권한을 영구적으로 삭제합니다.
             *
             * 권한을 영구적으로 삭제하면 자식 노드의 권한까지 모두 DB에서 물리적으로 삭제됩니다.
             */
            onDeletePermanentlyClicked(node) {
                this.$confirm('권한을 DB에서 물리적으로 삭제합니다. 모든 자식 권한이 제거되며. 절대로 다시 되돌릴 수 없습니다.')
                    .then(() => this.$confirm("정말로 영구적으로 삭제하시겠습니까?")
                        .then(() => this.requestDeletePermanently(node)));
            },

            /**
             * 서버에 권한 영구 삭제 요청을 합니다.
             */
            async requestDeletePermanently(node) {
                await this.$requestWithOverlay(PATH.SYSTEM_PERMISSION.DELETE_PERMANENTLY)
                    .setObject({id: node.id})
                    .enqueue();
                await this.loadPermissions();
            },

            /**
             * 권한이 추가, 삭제, 업데이트 되었습니다.
             */
            async onSystemPermissionReceived() {
                await this.loadPermissions();
            }
        },
    }
</script>

<style scoped>

</style>